<template>
    <div class="wrapper slim">
        <h3 class="block-title text-center" v-if="this.content.meta.title"><span class="block-title-content theme-tinted-border">{{this.content.meta.title}}</span></h3>
        <div class="flex-is-nice">
            <div v-for="recommendation in providerRecommendations" class="recommendation-item">
                <div class="item-wrapper" @click.prevent="openTab(recommendation.link)">
                    <img v-if="recommendation.contentUnit.file_name" class="recommendation-avatar-image" :src="context.storageEndpoint + (recommendation.contentUnit.thumbnail_file_name || recommendation.contentUnit.file_name)" />
                    <div class="recommendation-info">
                        <div class="provider-name">{{recommendation.name}}</div>
                        <p class="provider-content">{{recommendation.content}}</p>
                        <a :href="recommendation.link" target="_blank" style="word-break:break-all;">{{recommendation.link}}</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: ['block', 'providerId', 'context'],

        data: function() {
            const content = JSON.parse(this.block.content);

            return {
                id: this.block.id,
                content: content,
                informationBlock: this.block.information_block,
                providerRecommendations: content.providerRecommendations,
            };
        },

        methods: {
            openTab(link) {
                $('<a>').attr('href', link).attr('target', '_blank')[0].click();
            }
        }
    }
</script>

<style scoped>
    .flex-is-nice {
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
        padding-bottom: 24px;
    }

    .recommendation-item {
        width: 33%;
        display: flex;
        flex-direction: row;
        justify-content: center;
    }

    .recommendation-item .item-wrapper {
        width: 100%;
        border-radius: 4px;
        padding: 12px;
        margin: 12px;
        display: flex;
        flex-direction: row;
        background: #FFF;
    }

    .recommendation-info {
        padding: 0 12px;
    }

    .recommendation-info .provider-name {
        font-size: 18px;
        font-weight: bold;
    }

    .recommendation-info .provider-content {
        word-break: break-all;
        font-size: 16px;
        word-break: break-all;
    }

    @media only screen and (max-width: 768px) {
        .recommendation-item {
            width: 50%;
        }
    }

    @media only screen and (max-width: 600px) {
        .recommendation-item {
            width: 100%;
        }
    }

    .recommendation-avatar-image{
        flex-grow: 0;
        width: 78px;
        min-width: 78px;
        height: 78px;
        min-height: 78px;
        border-radius: 39px;
        overflow: hidden;
    }

</style>
